import SeoHead from "@/Component/Seo/SeoHead";
import ContactUs from "@/Component/Module/ContactUs";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function ContactUsPage({ seo, seoCountry }) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="Contact Us | Next Holidays" />
      <ContactUs />
    </>
  );
}

export async function getServerSideProps(context) {
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
    },
  };
}
